<template>
  <div>
    <v-dialog v-model="dialog" persistent eager scrollable max-width="600px">
      <v-form ref="CredsFormref" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex">
            <span>Manage Account</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="red"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <v-container>
              <v-col cols="12">
                <v-text-field
                  v-model="email"
                  :rules="[formRules.required]"
                  label="Email"
                  :color="$vuetify.theme.themes.light.inputColor"
                  variant="outlined"
                  density="compact"
                ></v-text-field>
              </v-col>
              <v-col cols="12" v-if="isReset">
                <v-text-field
                  v-model="newPass"
                  :rules="
                    isReset ? [formRules.required, formRules.password] : []
                  "
                  label="Password"
                  :color="$vuetify.theme.themes.light.inputColor"
                  :type="showPassword ? 'text' : 'password'"
                  :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append-inner="showPassword = !showPassword"
                  variant="outlined"
                  density="compact"
                  class="mb-5"
                />
              </v-col>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2">
            <v-spacer></v-spacer>

            <v-btn
              v-if="!isReset"
              variant="text"
              density="compact"
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
              @click="resetPassword()"
            >
              Reset Password
            </v-btn>
            <v-btn
              variant="outlined"
              density="compact"
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              @click="save()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <CheckPasswordDialog
      :showDialog="showPasswordCheck"
      v-on:validated="checkValidation"
    />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
import CheckPasswordDialog from "../CheckPasswordDialog.vue";
export default {
  props: {
    data: Object,
    action: String,
  },
  components: {
    CheckPasswordDialog,
  },
  data() {
    return {
      dialog: false,
      email: null,
      isReset: false,
      showPasswordCheck: false,
      showPassword: false,
      newPass: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.initialize();

        if (data.id) {
          console.log("Love", data);
          this.getEmail(data.id);
          // this.verifyModel.date_hired = data.emp_date_hired;
        }
      },
      deep: true,
    },
  },
  methods: {
    initialize() {
      this.userId = this.$store.state.user.id;
    },
    resetPassword() {
      this.isReset = true;
    },
    save() {
      this.showPasswordCheck = true;
    },
    checkValidation(validated) {
      this.showPasswordCheck = false;
      if (validated) {
        this.updateCreds();
      }
    },

    updateCreds() {
      let data = {
        email: this.email,
        password: this.newPass,
        isReset: this.isReset,
      };
      this.axiosCall(
        "/auth/update_org_creds/" + this.data.id,
        "PATCH",
        data,
      ).then((res) => {
        if (res.data.status == 200) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.closeD();
        } else if (res.data.status == 404) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },
    getEmail(id) {
      this.axiosCall("/user-details/getOrgUser/" + id, "GET").then((res) => {
        if (res.data) {
          this.email = res.data;
        }
      });
    },
    closeD() {
      eventBus.emit("closeManageCredentialsDialog", true);
      this.dialog = false;
    },
    accept() {
      if (this.$refs.UserVerifyFormref.validate()) {
        let data = {
          id: this.verifyModel.id,
          userID: this.verifyModel.userID,
          positionID: this.verifyModel.positionID,
          usertypeID: this.verifyModel.usertypeID,
          user_roleID: this.verifyModel.user_roleID,
          assignedModuleID: this.verifyModel.assignedModuleID,
          status: this.verifyModel.newStatus,
          update_type: this.action == "Verify" ? 1 : 2,
        };

        this.axiosCall("/user-details/updateVerifiedUser", "POST", data).then(
          (res) => {
            if (res.data.status == 200) {
              this.dialog = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.closeD();
            } else if (res.data.status == 400) {
              this.dialog = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.$refs.PositionFormref.reset();
              this.closeD();
            }
          },
        );
      }
    },
  },
};
</script>
